export default __webpack_public_path__ + "static/media/logoAdmin.aaaa5f3a.svg";